import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Panel = ({ label, children, headerExtras }) => {
	const [isCollapsed, setIsCollapsed] = useState(true);

	const handlePanelToggle = (event) => {
		event.preventDefault();
		setIsCollapsed(!isCollapsed);
	};

	return (
		<div className="panel panel-default">
			<div className={cn('panel-heading', { 'panel-heading-collapsed': isCollapsed })}>
				{label}
				<a
					href="#"
					data-tool="panel-collapse"
					data-toggle="tooltip"
					title=""
					className="pull-right"
					data-original-title="Collapse Panel"
					onClick={handlePanelToggle}
				>
					<em className={cn('fa', { 'fa-plus': isCollapsed, 'fa-minus': !isCollapsed })} />
				</a>
				{headerExtras}
			</div>
			<div
				className={cn('panel-wrapper', 'collapse', { 'in': !isCollapsed })}
				aria-expanded={!isCollapsed}
			>
				{children}
			</div>
		</div>
	);
};

Panel.propTypes = {
	label: PropTypes.string,
	children: PropTypes.node.isRequired,
	headerExtras: PropTypes.node,
};

export default Panel;
